'use strict';


function to_js_boolean(b) {
  if (b) {
    return true;
  } else {
    return false;
  }
}

exports.to_js_boolean = to_js_boolean;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// /usr/local/lib/node_modules/bs-platform/lib/js/js_boolean.js
// module id = 188
// module chunks = 0